import React from 'react';
import ProsesRombelPage from '@/components/rombel/ProsesRombelPage';

export default function WakaKurNaikKelasPage() {
  return <ProsesRombelPage badge="Kenaikan & Kelulusan (Waka Kurikulum)" />;
}
